"use client"

import {
  useEffect,
  memo,
} from "react"

import { useLocation } from "react-router-dom"

import useOrientation from "@/hooks/useOrientation"
import { useMusicContext } from "@/context/musicContext"

import usePlayerDrawer from "./hooks/usePlayerDrawer"

import DrawerContainer from "./components/DrawerContainer"
import PlayerContent from "./PlayerContent"

import {
  setGlobalOpenDrawer,
  clearGlobalOpenDrawer,
} from "./hooks/playerDrawerBridge"

/* =========================================================
   PLAYER DRAWER
========================================================= */

function PlayerDrawer() {
  const location = useLocation()

  const { isPortrait } =
    useOrientation()

  /* =======================================================
     MUSIC CONTEXT
     
     La información de la canción ya vive aquí.
     No necesitamos Redux ni PLAYLIST.
  ======================================================= */

  const {
    currentSong,
    currentTrackData,
    isPlaying,
  } = useMusicContext()

  /* =======================================================
     DRAWER STATE
  ======================================================= */

  const {
    open,
    setOpen,
    snap,
    setSnap,
    openDrawer,
  } = usePlayerDrawer()

  /* =======================================================
     GLOBAL BRIDGE
  ======================================================= */

  useEffect(() => {
    setGlobalOpenDrawer(openDrawer)

    return () => {
      clearGlobalOpenDrawer()
    }
  }, [openDrawer])

  /* =======================================================
     ROUTES
  ======================================================= */

  const isBlockedRoute =
    location.pathname === "/widget"

  /* =======================================================
     CURRENT IMAGE
  ======================================================= */

  const image =
    currentTrackData?.trackImg ??
    currentSong?.songimg ??
    undefined

  /* =======================================================
     GUARDS
  ======================================================= */

  if (!isPortrait) {
    return null
  }

  if (isBlockedRoute) {
    return null
  }

  /* =======================================================
     CLOSE
  ======================================================= */

  const handleClose = () => {
    setOpen(false)
  }

  /* =======================================================
     RENDER
  ======================================================= */

  return (
    <DrawerContainer
      open={open}
      setOpen={setOpen}
      image={image}
      snap={snap}
      setSnap={(value) => {
        if (typeof value === "number") {
          setSnap(value)
        }
      }}
    >
      <PlayerContent
        variant="drawer"
        onClose={handleClose}
      />
    </DrawerContainer>
  )
}

export default memo(PlayerDrawer)